import { render } from "./MeetingsArchive.vue?vue&type=template&id=4d9b50f1&scoped=true"
import script from "./MeetingsArchive.vue?vue&type=script&lang=js"
export * from "./MeetingsArchive.vue?vue&type=script&lang=js"

import "./MeetingsArchive.vue?vue&type=style&index=0&id=4d9b50f1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9b50f1"]])

export default __exports__